const menuList = [
	{
		title: "lang.设备列表",
		icon: 'iconmenu icon-shebeiguanli',
		img: null,
		route: "/deviceList",
		disabled: false,
	},
	{
		title: "lang.历史数据",
		icon: "iconmenu icon-lishishuju",
		img: null,
		route: "/historyData",
		disabled: false,
	},
	{
		title: "lang.收款明细",
		icon: 'iconmenu icon-caiwuzhongxin',
		img: null,
		route: "/collectionDetails",
		disabled: false,
	},
	{
		title: "lang.使用明细",
		icon: 'iconmenu icon-neirongguanli',
		img: null,
		route: "/usageDetails",
		disabled: false,
	},
]


export default menuList;